import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BrandWisePerformance from '@features/crm/v3/dashboard/components/BrandWisePerformance';
import IndividualPerformance from '@features/crm/v3/dashboard/components/IndividualPerformance';
import OverallPerformance from '@features/crm/v3/dashboard/components/OverallPerformance';
import Overview from '@features/crm/v3/dashboard/components/Overview';
import RegionalAdndDesignWisePerformance from '@features/crm/v3/dashboard/components/RegionalAdndDesignWisePerformance';
import { generateCRMDashboardParams } from '@features/filter/static/filterUtil';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { getCRMDashboardSummary } from '@services/crmService';

const CRMDashboard = ({ isIndividualUser }) => {
	const dispatch = useDispatch();
	const filterFields = useSelector((store) => store.filterFieldStore);
	const [summary, setSummary] = useState({});

	const getSelectedFilters = () => {
		return {
			isCountryExist: filterFields?.countryId?.[0]?.key,
			isBrandExist: filterFields?.brandId?.[0]?.key,
			isAccountManagerExist: filterFields?.accountManagerId?.[0]?.key
		};
	};

	const generateParams = () => {
		return {
			...generateCRMDashboardParams(filterFields, true)
		};
	};
	useEffect(() => {
		(async () => {
			try {
				dispatch(openLoader());
				const data = await getCRMDashboardSummary(generateParams());
				setSummary(data);
				dispatch(closeLoader());
			} catch {
				dispatch(closeLoader());
			}
		})();
	}, [filterFields]);

	return (
		<div className="body-content">
			<div className="mb-5">
				<Overview summary={summary} />
				<OverallPerformance />
				<RegionalAdndDesignWisePerformance summary={summary} isIndividualUser={isIndividualUser} />
			</div>

			<div className="performace-breakdown">
				<h3 className="semibold-14 mb-2">Performance Breakdown</h3>
				{!getSelectedFilters().isBrandExist && !getSelectedFilters().isAccountManagerExist && (
					<BrandWisePerformance />
				)}

				<IndividualPerformance />
			</div>
		</div>
	);
};

export default CRMDashboard;
